<div class="section-full  p-t80 testimonial-1-outer">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-12">
                <!-- TITLE START-->
                <div class="left wt-small-separator-outer">
                    <div class="wt-small-separator site-text-primary">
                        <div  class="sep-leaf-left"></div>
                        <div>{{data.title}}</div>
                        <div  class="sep-leaf-right"></div>
                    </div>
                    <h2>{{data.subtitle}}</h2>
                    <p>{{data.description}}</p>
                    <a routerLink="/other/contact1" class="site-button site-btn-effect">Contact Us</a>
                </div>
                <!-- TITLE END-->                        
            </div>
            <div class="col-lg-8 col-md-12">
                <div class="testimonial-1-content-outer">
                    <div class="testimonial-1-content owl-carousel  owl-btn-top-right long-arrow-next-prev">
                        <div class="item" *ngFor="let object of data.quotes">
                            <div class="testimonial-1 bg-white">
                                <div class="testimonial-content">
                                    <div class="testimonial-pic-block"> 
                                        <div class="testimonial-pic">
                                            <img src="{{object.image}}" alt="">
                                        </div>
                                    </div>                                            
                                    <div class="testimonial-text">
                                        <i class="fa fa-quote-left"></i>
                                        <p>{{object.quote}}</p>
                                    </div>
                                    <div class="testimonial-detail clearfix">
                                        <div class="testimonial-info">
                                            <span class="testimonial-name  title-style-2 site-text-secondry">{{object.name}}</span>
                                            <span class="testimonial-position title-style-2 site-text-primary">{{object.post}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>                                                                     
                    </div>
                </div>                     
            </div>
       </div>
    </div>
    <div class="hilite-large-title title-style-2">
        <span>{{data.quotesTitle}}</span>
    </div>
</div>